import { cn } from '@noor/lib';
import { macroLangSchema, type MacroLang } from '@/entities/conversation';

interface MacroLangToggleProps {
  value: MacroLang;
  onChange: (lang: MacroLang) => void;
  className?: string;
}

/** RU / UZ segmented switch — the language a macro is written in. */
export function MacroLangToggle({ value, onChange, className }: MacroLangToggleProps) {
  return (
    <div
      role="group"
      className={cn(
        'inline-flex items-center gap-0.5 rounded-lg border border-border bg-card p-0.5',
        className,
      )}
    >
      {macroLangSchema.options.map((lang) => (
        <button
          key={lang}
          type="button"
          aria-pressed={value === lang}
          onClick={() => onChange(lang)}
          className={cn(
            'min-w-9 rounded-md px-2 py-1 text-xs font-bold uppercase transition-colors focus-visible:ring-[3px] focus-visible:ring-ring/40 focus-visible:outline-none',
            value === lang
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:bg-muted hover:text-foreground',
          )}
        >
          {lang}
        </button>
      ))}
    </div>
  );
}
